export default "__VITE_ASSET___sRsZPxX__"